module.exports = __webpack_public_path__ + "static/img/title1.3e0bbb53.png";